<template>
  <div>
    <el-card shadow="always">
      <h1>菜单管理</h1>
      <el-button type="primary" @click="showAddMenuDialog = true">添加菜单</el-button>
      <el-table :data="menus" style="width: 100%">
        <el-table-column prop="name" label="菜单名称"></el-table-column>
        <el-table-column prop="path" label="路径"></el-table-column>
        <el-table-column prop="parent_id" label="父菜单ID"></el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="scope">
            <el-button size="small" @click="editMenu(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="deleteMenu(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加菜单弹窗 -->
      <el-dialog title="添加菜单" v-model="showAddMenuDialog" width="30%">
        <el-form :model="newMenu" label-width="100px" :rules="rules" ref="addMenuForm">
          <el-form-item label="菜单名称" prop="name">
            <el-input v-model="newMenu.name"></el-input>
          </el-form-item>
          <el-form-item label="路径" prop="path">
            <el-input v-model="newMenu.path"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="newMenu.sort"></el-input-number>
          </el-form-item>
          <el-form-item label="状态">
            <el-switch v-model="newMenu.status" active-text="启用" inactive-text="禁用"></el-switch>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="showAddMenuDialog = false">取消</el-button>
          <el-button type="primary" @click="submitAddMenu">保存</el-button>
        </template>
      </el-dialog>

      <!-- 编辑菜单弹窗 -->
      <el-dialog title="编辑菜单" v-model="showEditMenuDialog" width="30%">
        <el-form :model="editingMenu" label-width="100px">
          <el-form-item label="菜单名称">
            <el-input v-model="editingMenu.name"></el-input>
          </el-form-item>
          <el-form-item label="路径">
            <el-input v-model="editingMenu.path"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="editingMenu.sort"></el-input-number>
          </el-form-item>
          <el-form-item label="状态">
            <el-switch v-model="editingMenu.status" active-text="启用" inactive-text="禁用"></el-switch>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="showEditMenuDialog = false">取消</el-button>
          <el-button type="primary" @click="submitEditMenu">保存</el-button>
        </template>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';
import { ElMessage } from 'element-plus';  // 导入 ElMessage

export default {
  data() {
    return {
      menus: [],
      newMenu: { name: '', path: '', sort: 0, status: false },
      editingMenu: {},  // 修改为一个空对象
      showAddMenuDialog: false,
      showEditMenuDialog: false,
      rules: {
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        path: [{ required: true, message: '请输入路径', trigger: 'blur' }]
      }
    };
  },
  created() {
    this.fetchMenus();
  },
  methods: {
    async fetchMenus() {
      const res = await axios.get('/api/menus');
      this.menus = res.data.map(menu => ({
        ...menu,
        status: Boolean(menu.status)  // 确保 status 是布尔值
      }));
    },
    async submitAddMenu() {
      try {
        await this.$refs.addMenuForm.validate();
        await axios.post('/api/menus', this.newMenu);
        this.showAddMenuDialog = false;
        this.fetchMenus();
        ElMessage.success('菜单添加成功');
      } catch (error) {
        ElMessage.error(error.response.data.detail);
        console.error('添加菜单失败:', error);
      }
    },
    editMenu(menu) {
      // 将 status 字段从数字转换为布尔值
      this.editingMenu = {
        ...menu,
        status: Boolean(menu.status)  // 确保 status 是布尔值
      };
      this.showEditMenuDialog = true;
    },
    async submitEditMenu() {
      try {
        await axios.put(`/api/menus/${this.editingMenu.id}`, this.editingMenu);
        this.showEditMenuDialog = false;
        this.fetchMenus();
        ElMessage.success('菜单编辑成功');
      } catch (error) {
        ElMessage.error(error.response.data.detail);
        console.error('编辑菜单失败:', error);
      }
    },
    async deleteMenu(id) {
      try {
        await axios.delete(`/api/menus/${id}`);
        this.fetchMenus();
        ElMessage.success('菜单删除成功');
      } catch (error) {
        ElMessage.error('删除菜单失败');
        console.error('删除菜单失败:', error);
      }
    }
  }
};
</script>

<style scoped>
/* 确保样式没有覆盖表头 */
.el-table th {
  background-color: #f0f2f5;
  color: #333;
}
</style>
